import * as  config from "Config";


export function clearStore() {
  return {
    type: "DISCOUNT_CLEAR_STORE"
  };
}

export function saveNewDiscount(params) {
  let url = config.apiUrl + "/api/Discount";
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }

  return {
    remote: {
      method: "post",
      url,
      data: params
    },
    actions: ["DISCOUNT_NEW_SAVE_START", "DISCOUNT_NEW_SAVE_SUCCESS", "DISCOUNT_NEW_SAVE_FAIL"]
  };
}


export function saveDiscount(params) {
  let url = config.apiUrl + "/api/Discount/" + params.id;
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }
  return {
    remote: {
      method: "put",
      url,
      data: params
    },
    actions: ["DISCOUNT_SAVE_START", "DISCOUNT_SAVE_SUCCESS", "DISCOUNT_SAVE_FAIL"]
  };
}

export function getDetailDiscount(params) {
  let url = config.apiUrl + "/api/Discount/" + params.id;
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }
  return {
    remote: {
      method: "get",
      url
    },
    actions: ["DISCOUNT_DETAIL_START", "DISCOUNT_DETAIL_SUCCESS", "DISCOUNT_DETAIL_FAIL"]
  };
}

